import React from "react";
import YouTube from "react-youtube";
import { useRecoilValue } from "recoil";
import "./Promote.scoped.scss";
import { youtubeIdState } from "recoil/commonUiAtom";

function Promote() {
  const youtubeId = useRecoilValue(youtubeIdState);
  const videoOptions = {
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,
      mute: 1,
      showinfo: 0
    }
  };
  return (
    <div className="wrap-article" id="pagePromote">
      <div className="article img _0 clearfix">
        <YouTube
          videoId={youtubeId || ""} // defaults -> ''
          className={"promote-youtube"} // defaults -> ''
          iframeClassName={"promote-youtube-iframe"}
          opts={videoOptions}
          onEnd={(e) => {
            e.target.stopVideo(0);
          }}
        />
      </div>
    </div>
  );
}

export default Promote;
